import api, { paginado } from './apiClient'

/** `GET /zpl-templates?subCompanyId&search&limit&offset` */
export const getAllPrinterZpl = async data => {
  const response = await api.get('/zpl-templates', {
    params: {
      subCompanyId: data.subCompanyId,
      search: data.search || undefined,
      limit: data.limit,
      offset: data.offset,
    },
  })
  return { data: paginado(response) }
}

export const getPrinterZplById = async id => api.get(`/zpl-templates/${id}`)

export const createPrinterZpl = async data => api.post('/zpl-templates', data)

export const editPrinterZpl = async data => {
  const { zplTemplateId, ...corpo } = data
  return api.patch(`/zpl-templates/${zplTemplateId}`, corpo)
}

export const deletePrinterZpl = async zplTemplateId => api.delete(`/zpl-templates/${zplTemplateId}`)

/**
 * Pré-visualização da etiqueta pelo Labelary, como na tela antiga.
 *
 * É serviço público externo e recebe apenas o texto ZPL — nenhum dado de
 * produção sai daqui além do próprio layout. Não passa pela API porque é
 * apresentação: o back-end não precisa saber que a tela desenha um preview.
 */
export const previewZpl = async zpl => {
  const resposta = await fetch('https://api.labelary.com/v1/printers/8dpmm/labels/4x6/0/', {
    method: 'POST',
    headers: { Accept: 'image/png', 'Content-Type': 'application/x-www-form-urlencoded' },
    body: zpl,
  })
  if (!resposta.ok) {
    const detalhe = await resposta.text().catch(() => '')
    throw new Error(detalhe || 'O Labelary não conseguiu renderizar este ZPL.')
  }
  return URL.createObjectURL(await resposta.blob())
}
